module.exports = new __parcel__URL__("esfera_Vt.e061e4b0.png").toString();